<script>
import ContentTitle from '@/components/new-match-detail/ContentTitle.vue'
export default {
  components: {
    ContentTitle
  },
  data() {
    return {
      sportType: null,
      componentList: null,
      componentData: null,
      beginDate: null,
      endDate: null
    }
  },
}
</script>

<template>
  <div class="home-container">
    <div v-for="(item, index) in componentList" :key="index" class="content-box">
      <ContentTitle :information="item" :items="componentData && componentData[item.component]" />
    </div>
  </div>
</template>
<style scoped lang="scss">
.content-box{
  margin-top: 12px;
}
</style>